import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useComponentWillMount } from '../../hooks/useComponentWillMount';
import { getMediaPermissions, initVideo, setConsultState } from '../../redux/message/actions';
import PreConsultActionButton from './Instructions/PreConsultActionButton';
import styled from '@material-ui/core/styles/styled';
import Container from '@material-ui/core/Container';
import RequestCameraPermissions from './RequestCameraPermissions'
import RequestMicrophonePermissions from './RequestMicrophonePermissions'

const RequestMediaPermissions = () => {
  const dispatch = useDispatch();
  const permissionsStep = useSelector(state => state.messageState.permissionStep);
  const [title, setTitle] = useState('Please Wait...');
  const [text, setText] = useState(false);
  const [mediaScreen, setMediaScreen] = useState("all");

  useComponentWillMount(() => {
    dispatch(getMediaPermissions());
  });


  async function requestAvailableMedia() {
    const granted = { audio: false, video: false };

    try {
      await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
      granted.audio = true;
      granted.video = true;
    } catch (err) {
      console.warn("⚠️ Combined request failed. Falling back to individual requests.", err.name);
      // Fallback: The combined request failed, so now we ask one-by-one.
      // We create a new stream to combine the results.
      const combinedStream = new MediaStream();

      // Try to get audio
      try {
        const audioStream = await navigator.mediaDevices.getUserMedia({ audio: true });
        audioStream.getAudioTracks().forEach(track => combinedStream.addTrack(track));
        granted.audio = true;
      } catch (audioErr) {
        console.error("❌ Audio permission was denied.", audioErr.name);
      }

      // Try to get video
      try {
        const videoStream = await navigator.mediaDevices.getUserMedia({ video: true });
        videoStream.getVideoTracks().forEach(track => combinedStream.addTrack(track));
        granted.video = true;
      } catch (videoErr) {
        console.error("❌ Video permission was denied.", videoErr.name);
      }
    }

    return granted;
  }



  useEffect(() => {
    if (permissionsStep !== 'unknown') {
      setTitle('We need your permission!');
      setText(true);
    }
  }, [permissionsStep]);

  if (mediaScreen === 'video')
    return <RequestCameraPermissions/>;

  else if (mediaScreen === 'audio')
    return <RequestMicrophonePermissions/>;

  else
    return (
    <ContainerDiv>
      <LightTitle variant="h4" align="center">
        {title}
      </LightTitle>
      <br />
      {text && <MainText>VirtualCare needs access to your camera and microphone for your consultation</MainText>}
      <br />
      {text && <MainText>Please follow the steps below:</MainText>}
      <br />
      {text && <MainText>1. Click on the 'Grant Permission' button below</MainText>}
      {text && <MainText>2. Click 'ALLOW/ACCEPT' on the pop-ups that appear</MainText>}
      <br />
      {text && (
        <PreConsultActionButton
          id="GivePermissionButton"
          type="submit"
          color="primary"
          variant="contained"
          onClick={() => {
            requestAvailableMedia().then((permissions) => {
              if (permissions.video && permissions.audio) {
                dispatch(setConsultState('pre-consult'));
                dispatch(initVideo());
              }
              else if (permissions.audio === false) {
                setMediaScreen('audio');
              }
              else if (permissions.video === false && permissions.audio === true) {
                setMediaScreen('video');
              }

            });
          }}
        >
          Grant Permission
        </PreConsultActionButton>
      )}
      {text && <SubText>Still having trouble? Please check the camera and microphone settings on your device.</SubText>}
    </ContainerDiv>
  );
};

export default RequestMediaPermissions;

const ContainerDiv = styled(Container)({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});

const LightTitle = styled(Typography)({
  fontWeight: 300,
  paddingTop: 15,
  paddingBottom: 15,
});

const MainText = styled(Typography)({
  maxWidth: '95%',
  textAlign: 'center',
});

const SubText = styled(Typography)({
  maxWidth: '95%',
  textAlign: 'center',
  textSize: '0.75em',
});
